import { Modal as OrbitModal, Portal } from '@kiwicom/orbit-components';
import type { Props } from '@kiwicom/orbit-components/lib/Modal/types';

type OurProps = Readonly<
  Props & {
    readonly isVisible: boolean;
    readonly scrollingElementFn?: Props['scrollingElementRef'];
  }
>;

const Modal = (props: OurProps): JSX.Element | null => {
  const { isVisible } = props;

  if (!isVisible) {
    return null;
  }

  return (
    <Portal renderInto="modals">
      <OrbitModal {...props} scrollingElementRef={props.scrollingElementFn} />
    </Portal>
  );
};

export default Modal;
